'use strict';

var DefaultEvent = require('./exception-event-data/DefaultEvent.cjs');
var AxiosEvent = require('./exception-event-data/AxiosEvent.cjs');

function beforeSend(event, hint) {
  const eventData = eventDataFactory(event, hint);
  return editEvent(event, eventData);
}
function eventDataFactory(event, hint) {
  if (AxiosEvent.isAxiosErrorHint(hint)) {
    return new AxiosEvent(event, hint);
  }
  return new DefaultEvent(event);
}
function editEvent(event, data) {
  const originExceptionList = event.exception?.values;
  const titleException = originExceptionList?.[originExceptionList.length - 1];
  if (titleException) {
    titleException.type = data.getType();
    titleException.value = data.getValue();
  }
  return {
    ...event,
    level: data.getLevel(),
    fingerprint: data.getFingerPrint(),
    exception: event.exception,
    extra: { ...data.getExtra(), ...event.extra }
  };
}

module.exports = beforeSend;
//# sourceMappingURL=beforeSend.cjs.map
